import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './assets/i18n/en.json';
import sv from './assets/i18n/sv.json';
import nb from './assets/i18n/no.json';
import da from './assets/i18n/da.json';
import fi from './assets/i18n/fi.json';
import {isDKHost, isFIHost, isNOHost, isSEHost} from 'config';
import detector from 'i18next-browser-languagedetector';

const getDefaultLanguage = () => {
  if (isSEHost) return 'sv';
  if (isDKHost) return 'da';
  if (isNOHost) return 'nb';
  if (isFIHost) return 'fi';
  return 'sv';
};

i18n
  .use(initReactI18next)
  .use(detector)
  .init({
    resources: {
      en: {translation: en},
      sv: {translation: sv},
      nb: {translation: nb},
      da: {translation: da},
      fi: {translation: fi},
    },
    detection: {order: ['localStorage'], caches: ['localStorage']},
    fallbackLng: getDefaultLanguage(),
    interpolation: {escapeValue: false},
  });

document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lng) => (document.documentElement.lang = lng));
